import * as FileSaver from 'file-saver';
import * as xlsx from 'node-xlsx';

import { extractTableDataFromJson } from '@/utils/extractTableDataFromJson';


export const exportJsonTableToXLSX = (markdownContent: string) => {

  const date = new Date().toISOString().slice(0, 10).replace(/-/g, "_");
  const fileName = `FleetAssistant_${date}`;

  const tableData = extractTableDataFromJson(markdownContent);

  if (tableData.length > 0) {
    const data = [
      {
        name: 'Data',
        data: tableData,
      },
    ];

    // @ts-expect-error — node-xlsx WorkSheet type requires options property but build() accepts partial shape
    const buffer = xlsx.build(data);

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  }
};
